import React, { useMemo } from 'react';
import { useField } from 'react-final-form';
import { TextField } from 'ksnm-common-ui/lib/Form/InputFields';
import { createMask } from 'ksnm-common-ui/lib/MaskedInput';

export const LongField = (props: {
  name: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  key?: string;
}): React.ReactElement => {
  const {
    input: { value },
  } = useField(props.name);
  const mask = useMemo(() => createMask('ONLY_NUMBERS'), []);

  return <TextField {...props} maxLength={value?.includes('-') ? 28 : 27} mask={mask} />;
};
